/* eslint-disable camelcase */
import agree from '../../../assets/agree@2x.png'
import arrow from '../../../assets/arrow@2x.png'
import attention from '../../../assets/attention@2x.png'
import attentionBlue from '../../../assets/attention-blue@2x.png'
import back from '../../../assets/back@2x.png'
import blue_back_arrow from '../../../assets/blue_back_arrow@2x.png'
import call_state from '../../../assets/call_state@2x.png'
import caregiver_role from '../../../assets/caregiver_role@2x.png'
import close from '../../../assets/close@2x.png'
import communicator_faq from '../../../assets/communicator_faq@2x.png'
import finish from '../../../assets/finish@2x.png'
import fr_medical_id_booklet from '../../../assets/fr_medical_id_booklet@2x.png'
import fr_MIDbooklet_modelnum from '../../../assets/fr_MIDbooklet_modelnum@2x.png'
import fr_MIDbooklet_serialnum from '../../../assets/fr_MIDBooklet_serialnum@2x.png'
import fr_MIDbooklet_both_highlighted from '../../../assets/fr_MIDbooklet_both_highlighted@2x.png'
import flashing_heart from '../../../assets/flashing_heart@2x.png'
import spain_id_card from '../../../assets/spain_id_card@2x.png'
import spain_id_card_model from '../../../assets/spain_id_card_model@2x.png'
import spain_id_card_serial from '../../../assets/spain_id_card_serial@2x.png'
import spain_id_card_myinfo from '../../../assets/spain_id_card_myinfo@2x.png'
import green_state from '../../../assets/green_state@2x.png'
import green_state_header from '../../../assets/green_state_header@2x.png'
import group from '../../../assets/group@2x.png'
import heart from '../../../assets/heart@2x.png'
import heart_state from '../../../assets/heart_state@2x.png'
import heart_state_header from '../../../assets/heart_state_header@2x.png'
import ic_error_white from '../../../assets/ic_error_white@2x.png'
import id_card_model_number_en from '../../../assets/id_card_model_number_en@2x.png'
import id_card_model_number_es from '../../../assets/id_card_model_number_es@2x.png'
import id_card_serial_number_en from '../../../assets/id_card_serial_number_en@2x.png'
import id_card_serial_number_es from '../../../assets/id_card_serial_number_es@2x.png'
import id_image_en from '../../../assets/id_image_en@2x.png'
import id_image_es from '../../../assets/id_image_es@2x.png'
import info from '../../../assets/info@2x.png'
import home from '../../../assets/home@2x.png'
import home_focused from '../../../assets/home_focused@2x.png'
import jaguar_front_3d from '../../../assets/jaguar_front_3d@2x.png'
import landlineStep1 from '../../../assets/landlineStep1.png'
import landlineStep2 from '../../../assets/landlineStep2.png'
import landlineStep3 from '../../../assets/landlineStep3.png'
import landlineStep5 from '../../../assets/landlineStep5.png'
import lat_light from '../../../assets/lat_light@2x.png'
import lat_light_header from '../../../assets/lat_light_header@2x.png'
import learn from '../../../assets/learn@2x.png'
import learn_focused from '../../../assets/learn_focused@2x.png'
import lights from '../../../assets/lights@2x.png'
import lights_focused from '../../../assets/lights_focused@2x.png'
import logo_en from '../../../assets/logo_en@2x.png'
import logo_es from '../../../assets/logo_es@2x.png'
import logo_fr from '../../../assets/logo_fr@2x.png'
import logo_it from '../../../assets/logo_it@2x.png'
import logo_pt from '../../../assets/logo_pt@2x.png'
import medical_id_card from '../../../assets/medical_id_card@2x.png'
import menu from '../../../assets/menu@2x.png'
import more from '../../../assets/more@2x.png'
import more_focused from '../../../assets/more_focused@2x.png'
import next from '../../../assets/next@2x.png'
import no_lights from '../../../assets/no_lights@2x.png'
import no_lights_header from '../../../assets/no_lights_header@2x.png'
import one_collecting_wave from '../../../assets/one_collecting_wave@2x.png'
import one_collecting_wave_header from '../../../assets/one_collecting_wave_header@2x.png'
import one_sending_wave from '../../../assets/one_sending_wave@2x.png'
import one_sending_wave_header from '../../../assets/one_sending_wave_header@2x.png'
import patient_role from '../../../assets/patient_role@2x.png'
import power_connection from '../../../assets/power_connection@2x.png'
import red_doc from '../../../assets/red_doc@2x.png'
import red_doc_header from '../../../assets/red_doc_header@2x.png'
import save from '../../../assets/save@2x.png'
import sending_waves from '../../../assets/sending_waves@2x.png'
import small_heart from '../../../assets/small_heart@2x.png'
import step1 from '../../../assets/step1@2x.png'
import step2 from '../../../assets/step2@2x.png'
import step3 from '../../../assets/step3@2x.png'
import step4 from '../../../assets/step4@2x.png'
import step5 from '../../../assets/step5@2x.png'
import transparent_step1 from '../../../assets/transparent_step1@2x.png'
import transparent_step2 from '../../../assets/transparent_step2@2x.png'
import StatusButton from '../../../assets/StatusButton@2x.png'
import tap_image from '../../../assets/tap_image@2x.png'
import three_collecting_waves from '../../../assets/three_collecting_waves@2x.png'
import three_collecting_waves_header from '../../../assets/three_collecting_waves_header@2x.png'
import three_sending_waves from '../../../assets/three_sending_waves@2x.png'
import three_sending_waves_header from '../../../assets/three_sending_waves_header@2x.png'
import two_collecting_waves from '../../../assets/two_collecting_waves@2x.png'
import two_collecting_waves_header from '../../../assets/two_collecting_waves_header@2x.png'
import two_sending_waves from '../../../assets/two_sending_waves@2x.png'
import two_sending_waves_header from '../../../assets/two_sending_waves_header@2x.png'
import usb_ethernet_step_2 from '../../../assets/usb_ethernet_step_2@2x.png'
import usb_cellular_step_1 from '../../../assets/usb_cellular_step_1@2x.png'
import usb_cellular_step_2 from '../../../assets/usb_cellular_step_2@2x.png'
import usb_cellular_step_3 from '../../../assets/usb_cellular_step_3@2x.png'
import usb_cellular_step_4 from '../../../assets/usb_cellular_step_4@2x.png'
import usb_cellular_step_5 from '../../../assets/usb_cellular_step_5@2x.png'
import value_prop_device from '../../../assets/value_prop_device@2x.png'
import waves_state from '../../../assets/waves_state@2x.png'
import yellow_doc from '../../../assets/yellow_doc@2x.png'
import yellow_doc_header from '../../../assets/yellow_doc_header@2x.png'
import yellow_waves from '../../../assets/yellow_waves@2x.png'
import all_green_waves from '../../../assets/all_green_waves@2x.png'
import half_green_waves from '../../../assets/half_green_waves@2x.png'
import monitored_communicator from '../../../assets/monitoredCommunicator@2x.png'
import all_green_waves_transparent from '../../../assets/all_green_waves_transparent.png'
import press_heart_button from '../../../assets/press_heart_button.png'
import comm_working from '../../../assets/comm_working@2x.png'

const imageFiles = {
  agree,
  arrow,
  attention,
  'attention-blue': attentionBlue,
  back,
  blue_back_arrow,
  call_state,
  caregiver_role,
  close,
  communicator_faq,
  comm_working,
  finish,
  fr_medical_id_booklet,
  fr_MIDbooklet_modelnum,
  fr_MIDbooklet_serialnum,
  fr_MIDbooklet_both_highlighted,
  flashing_heart,
  spain_id_card,
  spain_id_card_model,
  spain_id_card_serial,
  spain_id_card_myinfo,
  green_state,
  green_state_header,
  group,
  heart,
  heart_state,
  heart_state_header,
  ic_error_white,
  id_card_model_number_en,
  id_card_model_number_es,
  id_card_serial_number_en,
  id_card_serial_number_es,
  id_image_en,
  id_image_es,
  info,
  home,
  home_focused,
  jaguar_front_3d,
  landlineStep1,
  landlineStep2,
  landlineStep3,
  landlineStep5,
  lat_light,
  lat_light_header,
  learn,
  learn_focused,
  lights,
  lights_focused,
  logo_en,
  logo_es,
  logo_fr,
  logo_it,
  logo_pt,
  medical_id_card,
  menu,
  more,
  more_focused,
  next,
  no_lights,
  no_lights_header,
  one_collecting_wave,
  one_collecting_wave_header,
  one_sending_wave,
  one_sending_wave_header,
  patient_role,
  power_connection,
  red_doc,
  red_doc_header,
  save,
  sending_waves,
  small_heart,
  step1,
  step2,
  step3,
  step4,
  step5,
  transparent_step1,
  transparent_step2,
  StatusButton,
  tap_image,
  three_collecting_waves,
  three_collecting_waves_header,
  three_sending_waves,
  three_sending_waves_header,
  two_collecting_waves,
  two_collecting_waves_header,
  two_sending_waves,
  two_sending_waves_header,
  usb_ethernet_step_2,
  usb_cellular_step_1,
  usb_cellular_step_2,
  usb_cellular_step_3,
  usb_cellular_step_4,
  usb_cellular_step_5,
  value_prop_device,
  waves_state,
  yellow_doc,
  yellow_doc_header,
  yellow_waves,
  all_green_waves,
  half_green_waves,
  monitoredCommunicator: monitored_communicator,
  all_green_waves_transparent,
  press_heart_button,
}

const loadImage = (file) => imageFiles[file]

const loadTranslatedImage = (root, locale) => {
  const language = locale ? locale.split('_')[0] : 'en'
  const file = `${root}_${language}`

  return imageFiles[file] || imageFiles[`${root}_en`]
}

export {
  loadImage, loadTranslatedImage,
}
